// extracted by mini-css-extract-plugin
export var sm = "768";
export var md = "1024";
export var lg = "1280";
export var xl = "1600";
export var wrapper = "IntroductionSection-module--wrapper--kB1m4";
export var listWrapper = "IntroductionSection-module--listWrapper--vyD+Q";
export var introWrapper = "IntroductionSection-module--introWrapper--KFJDi";
export var buttonWrapper = "IntroductionSection-module--buttonWrapper--M03IS";